// Async bootstrap required for Module Federation shared modules.
// Without this, eager shared modules race against MF initialization.
import('./bootstrap');
export {};
